module.exports = __webpack_public_path__ + "media/customizations/wildryelife/logo-ae71710fb73d98d114f7bafe5fa4b35e.png";